import { h } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const Panel = ({
  children,
  alignment = 'right',
  context = null,
  triggers = {},
  defaultOpen = false,
  hideHeader = false,
  overlay = false,
  overlayClasses = '',
  bodyScrollLock = false,
  classes = 'max-w-panel',
  duration,
  zIndex,
}) => {
  const {
    openTriggerEl = null,
    closeTriggerEl = null,
    toggleEl = null,
    openTriggerElsArray = null,
    closeTriggerElsArray = null,
  } = triggers;

  const [isOpen, setIsOpen] = useState(defaultOpen);
  const panelRef = useRef(null);
  const handleOpenEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
    if (hideHeader) {
      const headerEl = document.querySelector('[data-section="header"]');
      const promoEl = document.querySelector(
        '[data-section="promotional-banner"]',
      );
      headerEl.classList.add('hidden');
      promoEl?.classList?.add('hidden');
    }
    if (bodyScrollLock) {
      disableBodyScroll(panelRef.current, {
        // eslint-disable-next-line consistent-return
        allowTouchMove: (el) => {
          while (el && el !== document.body) {
            if (el === panelRef.current) {
              return true;
            }

            // eslint-disable-next-line no-param-reassign
            el = el.parentElement;
          }
        },
      });
    }
    if (duration) {
      setTimeout(() => {
        setIsOpen(false);
        const headerEl = document.querySelector('[data-section="header"]');
        const promoEl = document.querySelector(
          '[data-section="promotional-banner"]',
        );
        headerEl.classList.remove('hidden');
        promoEl?.classList?.remove('hidden');
        if (bodyScrollLock) {
          enableBodyScroll(panelRef.current);
        }
      }, duration);
    }
  };
  const handleCloseEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
    const headerEl = document.querySelector('[data-section="header"]');
    const promoEl = document.querySelector(
      '[data-section="promotional-banner"]',
    );
    headerEl.classList.remove('hidden');
    promoEl?.classList?.remove('hidden');
    if (bodyScrollLock) {
      enableBodyScroll(panelRef.current);
    }
  };
  const handleToggleEvent = () => {
    if (isOpen) {
      if (bodyScrollLock) {
        enableBodyScroll(panelRef.current);
      }
      setIsOpen(false);
    } else {
      if (bodyScrollLock) {
        disableBodyScroll(panelRef.current, {
          // eslint-disable-next-line consistent-return
          allowTouchMove: (el) => {
            while (el && el !== document.body) {
              if (el === panelRef.current) {
                return true;
              }

              // eslint-disable-next-line no-param-reassign
              el = el.parentElement;
            }
          },
        });
      }
      setIsOpen(true);
    }
  };

  useEffect(() => {
    if (openTriggerEl) openTriggerEl.addEventListener('click', handleOpenEvent);
    if (openTriggerElsArray)
      openTriggerElsArray.forEach((trigger) => {
        trigger.addEventListener('click', handleOpenEvent);
      });
    if (closeTriggerElsArray)
      closeTriggerElsArray.forEach((trigger) => {
        trigger.addEventListener('click', handleCloseEvent);
      });
    if (closeTriggerEl)
      closeTriggerEl.addEventListener('click', handleCloseEvent);
    if (toggleEl) toggleEl.addEventListener('click', handleToggleEvent);
    if (context) {
      document.addEventListener(`${context}:open`, handleOpenEvent);
      document.addEventListener(`${context}:close`, handleCloseEvent);
    }

    return () => {
      if (openTriggerEl)
        openTriggerEl.removeEventListener('click', handleOpenEvent);
      if (openTriggerElsArray)
        openTriggerElsArray.forEach((trigger) =>
          trigger.removeEventListener('click', handleOpenEvent),
        );
      if (closeTriggerElsArray)
        closeTriggerElsArray.forEach((trigger) => {
          trigger.removeEventListener('click', handleCloseEvent);
        });
      if (closeTriggerEl)
        closeTriggerEl.removeEventListener('click', handleCloseEvent);
      if (toggleEl) toggleEl.removeEventListener('click', handleToggleEvent);
      if (context) {
        document.removeEventListener(`${context}:open`, handleOpenEvent);
        document.removeEventListener(`${context}:close`, handleCloseEvent);
      }
    };
  }, [openTriggerEl, closeTriggerEl, toggleEl, openTriggerElsArray, context]);

  const alignmentClosedClasses = {
    right: 'translate-x-full',
    bottom: 'translate-y-full',
  };

  const alignmentClasses = {
    right: 'right-0',
    bottom: 'left-0 right-0 bottom-0 !top-auto',
    left: 'left-0',
  };

  const alignmentOpenClasses = {
    right: 'translate-x-0',
    bottom: 'translate-y-0',
  };

  return (
    <div>
      <div
        className={`w-full delay-75 z-40 transition-transform fixed inset-0 ${
          overlay && isOpen ? `bg-white opacity-80 ${overlayClasses}` : ''
        } ${isOpen ? 'h-full' : 'h-0'}`}
        onClick={handleCloseEvent}
      ></div>
      <div
        className={`
        block
        ${classes}
        w-full h-full
        fixed
        top-0
        bottom-0
        transition-transform
        ${zIndex || 'z-50'}
        bg-white
        ${alignmentClasses[alignment]} ${
          isOpen
            ? alignmentOpenClasses[alignment]
            : alignmentClosedClasses[alignment]
        }`}
        ref={panelRef}
      >
        {children}
      </div>
    </div>
  );
};

export default Panel;
